import Ship from './ship';

class Submarine extends Ship {
  constructor() {
    super(2);
  }
}

export default Submarine;
